const MAPS_API_KEY = 'AIzaSyDofsnCHjMPw4DVZgppsz27_9mv1J9oJEA';
const ABU_CENTER = { lat: 24.434712, lng: 54.408945 };

export {
  MAPS_API_KEY,
  ABU_CENTER
};
